function setPosition(element) {
  var verticalScroll = window.scrollY;
  var screenWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  if (verticalScroll >= 300 && screenWidth >= 992) {
    element.style.position = "fixed";
    element.style.borderBottom = "1px inset #ddd";
  }

  if (verticalScroll < 300 && screenWidth >= 992) {
    element.style.position = "relative";
    element.style.borderBottom = "none";
  }

  if (screenWidth < 992) {
    element.style.position = "fixed";
  }
}

(function () {
  var nav = document.querySelector(".navbar"),
    searchBtn = document.getElementById("search-btn"),
    searchForm = document.getElementById("sidebar-header"),
    shown = false;

  if (nav) {

    window.addEventListener("scroll", () => {
      setPosition(nav);
    });

    window.addEventListener("resize", () => {
      setPosition(nav);
    });

  }

  if (searchBtn && searchForm) {

    searchBtn.addEventListener("click", function () {
      if (!shown) {
        searchForm.style.right = "0";
        shown = true;
      } else {
        searchForm.style.right = "-999px";
        shown = false;
      }

    });

  }

  // scrollToFixed built with jQuery
  $(".sticky").scrollToFixed({ marginTop: 20, minWidth: 1438 });

})();